"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QA_QUALTRICS_ZONE_ID = exports.PROD_QUALTRICS_ZONE_ID = void 0;
// Details about this zones can be found in the wiki
// https://wiki.indeed.com/x/SNyhGw
exports.PROD_QUALTRICS_ZONE_ID = 'ZN_0V3UMpSnKZPMPl3';
exports.QA_QUALTRICS_ZONE_ID = 'ZN_7O6qRoe18btm8aW';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVhbHRyaWNzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnN0YW50cy9xdWFsdHJpY3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsb0RBQW9EO0FBQ3BELG1DQUFtQztBQUN0QixRQUFBLHNCQUFzQixHQUFHLG9CQUFvQixDQUFDO0FBQzlDLFFBQUEsb0JBQW9CLEdBQUcsb0JBQW9CLENBQUMifQ==